<template>
  <basic-dialog v-model="showTasks" :action-buttons="actionButtons" :subtle-loading="subtleLoading"
                :title="title">
    <v-card-text v-if="loading">
      <loading-indicator align-middle/>
    </v-card-text>
    <v-card-text v-else class="mt-5">
      <template v-for="task in filteredTasks">
        <task-card :key="task.id" :disabled="true" :task="task"/>
      </template>
      <v-row v-if="filteredTasks.length === 0" align="center" no-gutters>
        <no-content-view
          :description="$t('tasks.there_is_no_tasks_with_selected_filters')"
          :no-bottom-padding="true"
          :reload-button="false"
          :title="$t('tasks.no_tasks')"
          title-image="img/undraw_empty_re_opql.svg"
        />
      </v-row>
    </v-card-text>
  </basic-dialog>
</template>

<script>
import taskApi from "@/api/task";
import BasicDialog from "@/components/BasicDialog";
import TaskCard from "@/components/Tenant/Tasks/TaskCard";
import NoContentView from "@/components/NoContentView";
import LoadingIndicator from "@/public/components/LoadingIndicator";

export default {
  name: "TasksModal",
  components: {LoadingIndicator, NoContentView, TaskCard, BasicDialog},
  props: {
    category: {
      type: Object,
    },
    value: {
      type: Boolean,
    },
  },
  data() {
    return {
      showTasks: this.value,
      loading: false,
      subtleLoading: false,
    }
  },
  computed: {
    title() {
      return `${this.$tc('tasks.title', 2)} - ${this.category.nameText}`
    },
    tasks() {
      return this.$store.state.tasks;
    },
    filteredTasks() {
      let ts = [...(this.tasks || [])]
      ts = ts.filter(task => {
        return task.category && (
          [this.category?.id]?.includes(task.category.id) ||
          [this.category?.id]?.includes(task.category.parentCategory?.id) ||
          [this.category?.id]?.includes(task.category.parentCategory?.parentCategory?.id)
        )
      });
      return ts;
    },
    actionButtons() {
      return {
        close: {
          click: () => this.showTasks = false,
        },
        openTasks: {
          click: () => this.$router.push({name: 'tenant_tasks', params: {category: this.category?.id}}),
          text: this.$t('dashboard.open_tasks'),
          type: 'PRIMARY',
          icon: 'mdi mdi-arrow-right'
        }
      }
    },
  },
  methods: {
    async reload() {
      if (this.tasks.length > 0) {
        this.subtleLoading = true;
        this.loading = false;
      } else {
        this.subtleLoading = false;
        this.loading = true;
      }
      try {
        const tasks = await taskApi.getTasks();
        tasks.forEach(task => {
          task.searchString = `${task.name} ${task.description} ${task.userInCharge?.email} ${task.userInCharge?.firstName} ${task.userInCharge?.lastName} ${task.category?.nameText} ${task.category?.parentCategory?.nameText} ${task.category?.parentCategory?.parentCategory?.nameText} ${this.$formatYear(task.createdAt)}`
        })
        this.$store.dispatch('setTasks', tasks);
      } catch (error) {
        this.$handleApiError(error, this.$t('errors.error_loading_tasks'));
      }
      this.loading = false;
      this.subtleLoading = false;
    },
  },
  watch: {
    showTasks() {
      this.$emit('input', this.showTasks);
      if (this.showTasks) this.reload()
    },
    value(val) {
      this.showTasks = val;
    }
  },
}
</script>

<style scoped>

</style>
